module.exports = __webpack_public_path__ + "static/media/blog05.576efe18.png";